/* Sahane home: hero slideshow (scheduled slides, countdown, see-through header) + product tabs. */
(function () {
  if (window.__wzHome) return;
  window.__wzHome = true;

  function pkt(s) {
    if (!s) return NaN;
    var m = String(s).trim().match(/^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{1,2}):(\d{2}))?/);
    if (!m) return NaN;
    return Date.UTC(+m[1], +m[2] - 1, +m[3], (+m[4] || 0) - 5, +m[5] || 0);
  }
  function eligible(el, now) {
    var f = pkt(el.getAttribute('data-from')), u = pkt(el.getAttribute('data-until'));
    if (!isNaN(f) && now < f) return false;
    if (!isNaN(u) && now >= u) return false;
    return true;
  }

  function hero(root) {
    var slides = [].slice.call(root.querySelectorAll('.wz-hero__slide'));
    var now = Date.now();
    slides.forEach(function (s) { if (eligible(s, now)) s.hidden = false; else { s.hidden = true; s.classList.remove('is-active'); } });
    var live = slides.filter(function (s) { return !s.hidden; });
    if (!live.length) { root.style.display = 'none'; return; }
    var idx = Math.max(0, live.findIndex(function (s) { return s.classList.contains('is-active'); }));
    var dotsBox = root.querySelector('[data-wz-dots]');
    var dots = [];
    if (dotsBox && live.length > 1) {
      live.forEach(function (s, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        b.addEventListener('click', function () { go(i); restart(); });
        dotsBox.appendChild(b);
        dots.push(b);
      });
    }
    var under = root.classList.contains('wz-hero--under');
    function tone() {
      var light = live[idx].getAttribute('data-tone') === 'light';
      root.classList.toggle('is-light', light);
      document.documentElement.classList.toggle('wz-hdr-light', under && light);
    }
    function go(i) {
      idx = (i + live.length) % live.length;
      live.forEach(function (s, k) { s.classList.toggle('is-active', k === idx); });
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === idx); });
      var img = live[idx].querySelector('img[loading="lazy"]');
      if (img) img.loading = 'eager';
      tone();
    }
    go(idx);
    var ms = (parseFloat(root.getAttribute('data-autoplay')) || 0) * 1000, timer = null, paused = false;
    function restart() { clearInterval(timer); if (ms && live.length > 1) timer = setInterval(function () { if (!paused && !document.hidden) go(idx + 1); }, ms); }
    restart();
    root.addEventListener('mouseenter', function () { paused = true; });
    root.addEventListener('mouseleave', function () { paused = false; });
    var x0 = null, y0 = null;
    root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (x0 == null) return;
      var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) { go(idx + (dx < 0 ? 1 : -1)); restart(); }
      x0 = null;
    });
    var down = root.querySelector('.wz-hero__down');
    if (down) down.addEventListener('click', function (e) {
      e.preventDefault();
      var hdr = document.getElementById('shopify-section-header-inline');
      var y = root.getBoundingClientRect().bottom + window.scrollY - (hdr ? hdr.offsetHeight : 0);
      window.scrollTo({ top: y, behavior: 'smooth' });
    });

    /* see-through header (desktop / tablet only) */
    if (under) {
      var html = document.documentElement, hdr = document.getElementById('shopify-section-header-inline');
      var mq = window.matchMedia('(min-width: 768px)');
      var setH = function () { if (hdr) html.style.setProperty('--wz-hdr-h', hdr.offsetHeight + 'px'); };
      var onScroll = function () { html.classList.toggle('wz-hdr-solid', window.scrollY > 10); };
      var apply = function () { html.classList.toggle('wz-hdr-over', mq.matches); setH(); onScroll(); };
      apply();
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', setH);
      if (mq.addEventListener) mq.addEventListener('change', apply); else if (mq.addListener) mq.addListener(apply);
    }
  }

  function countdowns() {
    var els = [].slice.call(document.querySelectorAll('[data-wz-countdown]'));
    if (!els.length) return;
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      var now = Date.now();
      els.forEach(function (el) {
        var t = pkt(el.getAttribute('data-wz-countdown')), d = t - now;
        if (isNaN(t) || d <= 0) { el.classList.add('is-done'); return; }
        var s = Math.floor(d / 1000);
        el.querySelector('[data-d]').textContent = pad(Math.floor(s / 86400));
        el.querySelector('[data-h]').textContent = pad(Math.floor(s % 86400 / 3600));
        el.querySelector('[data-m]').textContent = pad(Math.floor(s % 3600 / 60));
        el.querySelector('[data-s]').textContent = pad(s % 60);
      });
    }
    tick();
    setInterval(tick, 1000);
  }

  function tabs(root) {
    var btns = [].slice.call(root.querySelectorAll('.wz-tabs__tab'));
    var all = root.querySelector('[data-wz-tabs-all]');
    btns.forEach(function (b) {
      b.addEventListener('click', function () {
        btns.forEach(function (o) {
          var on = o === b;
          o.classList.toggle('is-active', on);
          o.setAttribute('aria-selected', on ? 'true' : 'false');
          var p = document.getElementById(o.getAttribute('aria-controls'));
          if (p) p.hidden = !on;
        });
        if (all) all.setAttribute('href', b.getAttribute('data-url'));
      });
    });
  }

  function start() {
    [].forEach.call(document.querySelectorAll('[data-wz-hero]'), hero);
    [].forEach.call(document.querySelectorAll('[data-wz-tabs]'), tabs);
    countdowns();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', function () { window.__wzHome = false; });
})();
